export default class ElectronFiscalService {

    constructor() {
        this.pac = null
        this.cert = null
        this.key = null
        this.esdcUrl = null
    }

    async init(options = {}) {
        const { esdcUrl } = options;

        this.esdcUrl = esdcUrl
        this.pac = await AppStorage.native().getItem('pac')
        this.cert = await AppStorage.native().getItem('cert')
        this.key = await AppStorage.native().getItem('key')

        await window.electron.invoke('el-sdc-init', {
            pac: this.pac,
            cert: this.cert,
            key: this.key,
            esdcUrl: this.esdcUrl
        })
    }

    async chooseCertificate(password, pac) {
        const chooseCertificateResult = await window.electron.invoke('el-cert-choose', password, pac)
        if(chooseCertificateResult.success) {
            AppStorage.native().setItem('pac', chooseCertificateResult.pac)
            AppStorage.native().setItem('cert', chooseCertificateResult.cert)
            AppStorage.native().setItem('key', chooseCertificateResult.key)

            this.pac = chooseCertificateResult.pac
            this.cert = chooseCertificateResult.cert
            this.key = chooseCertificateResult.key

            await window.electron.invoke('el-sdc-init', {
                pac: this.pac,
                cert: this.cert,
                key: this.key,
                esdcUrl: this.esdcUrl
            })
        }

        return { success: chooseCertificateResult.success }
    }

    async verifyPin(pin, sdc) {
        return await window.electron.invoke('el-sdc-verify-pin', { pin, sdc })
    }

    async createInvoice(invoice, sdc) {
        return await window.electron.invoke('el-sdc-create-invoice', { invoice, sdc })
    }

    async getInvoice(requestId, sdc) {
        return await window.electron.invoke('el-sdc-get-invoice', { requestId, sdc })
    }

    async getEnvironmentParameters(sdc) {
        return await window.electron.invoke('el-sdc-get-environment-parameters', { sdc })
    }

    async getStatus(sdc) {
        return await window.electron.invoke('el-sdc-get-status', { sdc })
    }

    async getAttention(sdc) {
        return await window.electron.invoke('el-sdc-get-attention', { sdc })
    }

    async getUiData(sdc) {
        return await window.electron.invoke('el-sdc-get-ui-data', { sdc })
    }

    async storeLocalAuditFiles(sdc) {
        return { error: { code: 'not_supported_on_external_sdc' } }
    }

    async executeCommandsFromStorage(sdc) {
        return { error: { code: 'not_supported_on_external_sdc' } }
    }
}
